import * as React from 'react';
import ProjectLayout from '../ProjectLayout';
import { useMsgText } from '../../localization/hooks';
import { Str } from '../../localization/translationKeys';
import SurveyHeader from '../survey/SurveyHeader';
import { css } from '@emotion/core';
import { COLORS } from '../../globalStyle/colors';
import { onMobileDevice } from '../../globalStyle/mediaQueries';


const styles = {
  content:       css`
    margin-top: 62px;
    background-color: ${COLORS.WHITE};
    width: 100%;

    ${onMobileDevice} {
      margin-top: 20px;
    }
  `,
  header: css`
    ${onMobileDevice} {
      margin-top: 37px;
    }  
  `,
};


type Props = {
  className?: string;
};


/**
 * ReportTutorial: a component that displays a report tutorial video
 *
 * PureComponent: true
 * Redux Connected: false
 */
const ReportTutorial: React.FC<Props> = props => {
  const pageTitle = useMsgText(Str.ReportTutorial);

  //TODO - video won't play. Could play local with Windows Media Player but not Movies & TV or Photos

  return (
    <ProjectLayout className={props.className}>
      <SurveyHeader title={`/ ${pageTitle}`} deadline={undefined} css={styles.header}/>
      <video css={styles.content} controls>
         <source src='../../assets/tutorial.mp4' type='video/mp4' />
         Browser does not support the video tag.
      </video>
    </ProjectLayout>
  )

};

export default ReportTutorial;
